import { useState } from "react";
import { motion } from "framer-motion";
import { Trash } from "lucide-react";

const ConfirmModal = ({
  isOpen,
  onClose,
  onConfirm,
  title,
  message,
  confirmText = "Confirm",
  cancelText = "Cancel",
  warning = false,
  requiresSecretKey = false,
  details = false,
}) => {
  const [secretKey, setSecretKey] = useState("");
  const [invoiceName, setInvoiceName] = useState("");
  const [description, setDescription] = useState("");
  const [error, setError] = useState("");

  if (!isOpen) return null;

  const confirmButtonClasses = warning
    ? "px-5 py-2 text-white bg-gradient-to-r from-red-500 to-red-700 hover:from-red-600 hover:to-red-800 rounded-lg transition-all"
    : "px-5 py-2 text-white bg-gradient-to-r from-blue-500 to-blue-700 hover:from-blue-600 hover:to-blue-800 rounded-lg transition-all";

  const cancelButtonClasses = "px-5 py-2 text-gray-700 bg-gradient-to-r from-gray-200 to-gray-300 hover:from-gray-300 hover:to-gray-400 rounded-lg transition-all";

  const cardClasses = warning
    ? "bg-red-100 p-6 md:p-8 rounded-2xl shadow-xl max-w-sm w-full text-center transform scale-100 transition-transform duration-300"
    : "bg-white p-6 md:p-8 rounded-2xl shadow-xl max-w-sm w-full text-center transform scale-100 transition-transform duration-300";

  const handleConfirm = () => {
    if (details && !invoiceName.trim()) {
      setError("Master Invoice Name is required");
      return;
    }
    setError("");
    onConfirm({ secretKey, invoiceName, description });
    onClose();
  };

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 backdrop-blur-sm animate-fadeIn">
      <div className={cardClasses}>
        {/* Modal Title */}
        <h2 className="text-xl font-bold text-gray-900">{title}</h2>

        {/* Modal Message */}
        <p className="text-gray-600 mt-2 text-sm">{message}</p>

        {/* Secret Key Input */}
        {requiresSecretKey && (
          <input
            type="password"
            className="mt-4 w-full px-4 py-2 border rounded-lg text-gray-700"
            placeholder="Enter Secret Key"
            value={secretKey}
            onChange={(e) => setSecretKey(e.target.value)}
          />
        )}

        {/* Additional Details Input Fields */}
        {details && (
          <>
            <input
              type="text"
              className="mt-4 w-full px-4 py-2 border rounded-lg text-gray-700"
              placeholder="Master Invoice Name"
              value={invoiceName}
              onChange={(e) => setInvoiceName(e.target.value)}
            />
            {error && <p className="text-red-500 text-sm">{error}</p>}

            <textarea
              className="mt-4 w-full px-4 py-2 border rounded-lg text-gray-700"
              placeholder="Description (Optional)"
              value={description}
              onChange={(e) => setDescription(e.target.value)}
            />
          </>
        )}

        {/* Action Buttons */}
        <div className="mt-6 flex justify-center gap-4">
          <button className={cancelButtonClasses} onClick={onClose}>
            {cancelText}
          </button>
          <button
            className={confirmButtonClasses}
            onClick={handleConfirm}
            disabled={(requiresSecretKey && !secretKey) || (details && !invoiceName.trim())}
          >
            {confirmText}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmModal;
